import { Injectable } from '@angular/core';
import {
  EntityCollectionServiceBase,
  EntityCollectionServiceElementsFactory
} from '@ngrx/data';

import { GrupoEspecieTipoActividad } from './grupos-especie-tipo-actividad.model';

@Injectable({ providedIn: 'root' })
export class GruposEspecieTipoActividadService extends EntityCollectionServiceBase<GrupoEspecieTipoActividad> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
    super('GrupoEspecieTipoActividad', serviceElementsFactory);
  }
}
